import type { Props } from './Svg'
import { Svg } from './Svg'

export function DownloadIcon(props: Props) {
  return (
    <Svg width="20" height="20" fill="currentColor" stroke="none" {...props}>
      <path d="M10 16.2 2 8.9l1.4-1.1L9 13V0h1.8v13l5.7-5.3L18 9l-8 7.2Zm8.2-1.2v2.5c0 .5-.4.8-1 .8H2.8c-.5 0-.9-.3-.9-.8V15H0v2.5C0 18.9 1.2 20 2.7 20h14.6c1.5 0 2.7-1.1 2.7-2.5V15h-1.8Z" />
    </Svg>
  )
}
